class LoginController {
    constructor($state, authService, apiSuppliersService, sharedService, cacheService) {
        'ngInject';

        this.$state = $state;
        this.authService = authService;
        this.apiSuppliersService = apiSuppliersService;
        this.loader = sharedService.loader;
        this.cacheService = cacheService;

        // TODO: use translations from $translate service

        // Reset login data to defaults
        this.error = false;
        this.cacheService.delete('supplier');

    }

    login() {
        //TODO Use arrow function chaining promises
        //authenticate and set the auth header
        var self = this;

        //Avoid massive requests
        if (this.loader.visible) {
            return;
        }
        this.loader.visible = true;
        this.authService.login(this.email, this.password)
            .then((response) => {
                return this.apiSuppliersService.me.get().$promise.then(response => {                    
                    return response;
                });
            })
            .then((response) => {
                this.cacheService.set('supplier', response);
                this.$state.go('home');
            })
            .catch(error => {
                //TODO manage the error with new relic
                this.error = true;
                this.authService.logout();
            }).finally(() => {
            this.loader.visible = false;
        });
    }

}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/auth/login/login.controller.js